export default __webpack_public_path__ + "static/media/Kasia.5c33fa44.jpg";